import React, {
	createContext,
	type Dispatch,
	type PropsWithChildren,
	type SetStateAction,
	useContext,
	useState,
} from 'react';

import noop from 'lodash/noop';

export const WillRedirectOnLoadContext = createContext(false);

export const SetWillRedirectOnLoadContext = createContext<Dispatch<SetStateAction<boolean>>>(noop);

export const WillRedirectOnLoadProviders = ({ children }: PropsWithChildren) => {
	const [willRedirectOnLoad, setWillRedirectOnLoad] = useState(false);

	return (
		<WillRedirectOnLoadContext.Provider value={willRedirectOnLoad}>
			<SetWillRedirectOnLoadContext.Provider value={setWillRedirectOnLoad}>
				{children}
			</SetWillRedirectOnLoadContext.Provider>
		</WillRedirectOnLoadContext.Provider>
	);
};

export const useWillRedirectOnLoad = () => useContext(WillRedirectOnLoadContext);
export const useSetWillRedirectOnLoad = () => useContext(SetWillRedirectOnLoadContext);
